module.exports = __webpack_public_path__ + "b5f10269e43e8d9eb5e7a2837f959564.svg";